import { Button } from "react-bootstrap";
import { FaPlus } from "react-icons/fa";
import { Link } from "react-router-dom";
import { TagList } from "../../components/TagList/TagList";
import { useCart } from "../../hooks/use-cart";
import { SearchableInvestorEntry } from "../../types/SearchableInvestorEntry";
import "./InvestorCard.scss";

interface InvestorCardProps {
  investor: SearchableInvestorEntry;
  sectorFocusHighlight?: string;
  stageFocusHighlight?: string;
  showAdminControls?: boolean;
}

const InvestorCard: React.FC<InvestorCardProps> = ({
  investor,
  sectorFocusHighlight,
  stageFocusHighlight,
  showAdminControls = false,
}) => {
  const { addToCart } = useCart();

  return (
    <div className="investor-card">
      <div className="investor-name">
        <span>{investor.name}</span>
        <Button
          className="icon-button"
          variant="outline-primary"
          onClick={() => addToCart(investor)}
        >
          <FaPlus />
          <span>Add to Export Cart</span>
        </Button>
      </div>
      <div className="investor-details">
        {investor.investorRole && (
          <span className="investor-role">{investor.investorRole}</span>
        )}
        {investor.stageFocus && investor.stageFocus.length > 0 && (
          <div className="stage-focus">
            <div className="stage-focus-label">Stages</div>
            <TagList<string>
              tags={investor.stageFocus}
              sort
              thingRoute={`/investors/search?stageFocus=$VALUE`}
              thingName={{ singular: "stage", plural: "stages" }}
              highlight={stageFocusHighlight}
              showHighlightedTagsFirst
              collapsible
            />
          </div>
        )}
        {investor.sectorFocus && investor.sectorFocus.length > 0 && (
          <div className="sector-focus">
            <div className="sector-focus-label">Sectors</div>
            <TagList<string>
              tags={investor.sectorFocus}
              sort
              showHighlightedTagsFirst
              collapsible
              highlight={sectorFocusHighlight}
              thingRoute={`/investors/search?sectorFocus=$VALUE`}
              thingName={{ singular: "sector", plural: "sectors" }}
            />
          </div>
        )}
      </div>
      <div className="contact-info">
        <div className="contact-info-label">Contact Information Available</div>
        <div className="contact-info-badges">
          {investor.hasEmail && (
            <span className="contact-badge email">Email</span>
          )}
          {investor.hasPhone && (
            <span className="contact-badge phone">Phone</span>
          )}
          {investor.hasLinkedIn && (
            <span className="contact-badge linkedin">LinkedIn</span>
          )}
          {investor.hasTwitter && (
            <span className="contact-badge twitter">Twitter</span>
          )}
          {investor.hasCrunchbase && (
            <span className="contact-badge crunchbase">Crunchbase</span>
          )}
        </div>
      </div>
      {showAdminControls && investor.importedInvestorId && (
        <div className="admin-controls">
          <div className="header">Admin</div>
          <Link to={`/admin?importedInvestorId=${investor.importedInvestorId}`}>
            Debug Mapping
          </Link>
        </div>
      )}
    </div>
  );
};

export default InvestorCard;
